import api, { ResponsePayloadWithData } from '.';

interface SchoolBase {
  id: string;
  name: string;
}

export interface SchoolResponse extends SchoolBase {
  address: {
    city: string;
    streetName: string;
    streetNumber: string;
    zipCode: string;
  };
}

export interface School extends SchoolResponse {
  isSmartschool: false;
}

export interface SmartschoolSchool extends SchoolBase {
  domain: string;
  isSmartschool: true;
}

export type UserSchool = School | SmartschoolSchool;

export async function fetchUserSchools(search?: string) {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<UserSchool[]>>('/studio/user/schools', { params: { search } });

  return data;
}
